var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVaultIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 15.1673H5.9987C2.3787 15.1673 0.832031 13.6207 0.832031 10.0007V6.00065C0.832031 2.38065 2.3787 0.833984 5.9987 0.833984H9.9987C13.6187 0.833984 15.1654 2.38065 15.1654 6.00065V10.0007C15.1654 13.6207 13.6187 15.1673 9.9987 15.1673ZM5.9987 1.83398C2.92536 1.83398 1.83203 2.92732 1.83203 6.00065V10.0007C1.83203 13.074 2.92536 14.1673 5.9987 14.1673H9.9987C13.072 14.1673 14.1654 13.074 14.1654 10.0007V6.00065C14.1654 2.92732 13.072 1.83398 9.9987 1.83398H5.9987Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73333 13H4.5C4.22667 13 4 12.7733 4 12.5C4 12.2267 4.22667 12 4.5 12H5.73333C6.00667 12 6.23333 12.2267 6.23333 12.5C6.23333 12.7733 6.00667 13 5.73333 13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22752 11H4.43915C4.19908 11 4 10.7733 4 10.5C4 10.2267 4.19908 10 4.43915 10H8.22752C8.46759 10 8.66667 10.2267 8.66667 10.5C8.66667 10.7733 8.47344 11 8.22752 11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3346 4.33398H5.66797C5.11568 4.33398 4.66797 4.7817 4.66797 5.33398V7.00065C4.66797 7.55294 5.11568 8.00065 5.66797 8.00065H10.3346C10.8869 8.00065 11.3346 7.55294 11.3346 7.00065V5.33398C11.3346 4.7817 10.8869 4.33398 10.3346 4.33398ZM5.66797 3.33398C4.5634 3.33398 3.66797 4.22941 3.66797 5.33398V7.00065C3.66797 8.10522 4.5634 9.00065 5.66797 9.00065H10.3346C11.4392 9.00065 12.3346 8.10522 12.3346 7.00065V5.33398C12.3346 4.22941 11.4392 3.33398 10.3346 3.33398H5.66797Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultIcon);
export default __webpack_public_path__ + "static/media/vaultIcon.61d826e9.svg";
export { ForwardRef as ReactComponent };